/* External dependencies */
import { Div } from 'atomize';
import React, { ReactNode } from 'react';

interface PopupActionsProps {
  children: ReactNode;
}

export function PopupActions(props: PopupActionsProps) {
  const { children } = props;

  return (
    <Div d="flex" justify="center" p={{ x: '1.5rem', y: '1rem' }}>
      {children}
    </Div>
  );
}
